import Bloodhound from 'corejs-typeahead/dist/typeahead.bundle.js'
globalThis.Bloodhound = Bloodhound;
import '@appPath/helpers/autocomplete/autocomplete.js';
import 'ddslick/dist/jquery.ddslick.min.js';
import moment from 'moment';

import('moment/locale/en-gb');
import('moment/locale/de');
import('moment/locale/da.js');
import('moment/locale/es.js');
import('moment/locale/sv.js');
import('moment/locale/tr.js');
import('moment/locale/ro.js');
import('moment/locale/fr.js');
import('moment/locale/it.js');
import('moment/locale/ru.js');


globalThis.moment = moment;
import '@appPath/helpers/tab/dropdown-tab-helper.js';